import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectPolyLassoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M7.22001 17.06C7.02001 15.5 5.68002 14.3 4.07001 14.3C2.32001 14.3 0.890015 15.73 0.890015 17.48C0.890015 19.23 2.32001 20.66 4.07001 20.66C5.35001 20.66 6.46001 19.9 6.96001 18.8C7.60001 19.42 8.04002 20.17 8.18002 20.92C8.26002 21.36 8.28001 22.01 7.87001 22.58C7.63001 22.92 7.70001 23.38 8.04001 23.63C8.37001 23.87 8.84001 23.8 9.09001 23.46C9.66001 22.67 9.86001 21.69 9.66001 20.65C9.40001 19.31 8.50001 18 7.23001 17.08L7.22001 17.06ZM4.07001 19.15C3.14001 19.15 2.39001 18.4 2.39001 17.47C2.39001 16.54 3.14001 15.79 4.07001 15.79C5.00001 15.79 5.75001 16.54 5.75001 17.47C5.75001 18.4 5.00001 19.15 4.07001 19.15Z"
        fill={color}
      />
      <path
        d="M20.35 17.78C19.94 17.72 19.56 17.99 19.49 18.4L19.37 19.14L17.15 18.79C16.74 18.73 16.36 19.01 16.29 19.41C16.23 19.82 16.5 20.2 16.91 20.27L19.87 20.74C20.28 20.8 20.66 20.53 20.73 20.12L20.96 18.64C21.02 18.23 20.75 17.85 20.34 17.78H20.35Z"
        fill={color}
      />
      <path
        d="M21.36 11.36C20.95 11.3 20.57 11.57 20.5 11.98L19.99 15.19C19.93 15.6 20.2 15.98 20.61 16.05C21.02 16.11 21.4 15.84 21.47 15.43L21.98 12.22C22.04 11.81 21.77 11.43 21.36 11.36Z"
        fill={color}
      />
      <path
        d="M22.38 4.95001C21.97 4.89001 21.59 5.16001 21.52 5.57001L21.01 8.78001C20.95 9.19001 21.22 9.57001 21.63 9.64001C22.04 9.70001 22.42 9.43001 22.49 9.02001L23 5.81001C23.06 5.40001 22.79 5.02001 22.38 4.95001Z"
        fill={color}
      />
      <path
        d="M23.43 0.390001C23.2 0.220001 22.89 0.210001 22.64 0.340001L21.34 1.05C20.96 1.25 20.83 1.73 21.03 2.1C21.22 2.45 21.66 2.58 22.02 2.39C21.96 2.79 22.23 3.16 22.62 3.22C23.04 3.29 23.44 3 23.5 2.58L23.73 1.12C23.77 0.840001 23.65 0.550001 23.42 0.390001H23.43Z"
        fill={color}
      />
      <path
        d="M10.9 7.48001C11.27 7.55001 12 7.90001 12.35 7.66001L14.16 6.67001C14.52 6.47001 14.66 6.02001 14.46 5.65001C14.26 5.29001 13.81 5.15001 13.44 5.35001L11.9 6.19001L11.29 6.02001C10.89 5.91001 10.48 6.15001 10.37 6.55001C10.26 6.95001 10.5 7.36001 10.9 7.47001V7.48001Z"
        fill={color}
      />
      <path
        d="M5.14 5.91001L8.02 6.70001C8.42 6.81001 8.83 6.57001 8.94 6.17001C9.05 5.77001 8.81 5.36001 8.41 5.25001L5.53 4.46001C5.13 4.35001 4.72 4.59001 4.61 4.99001C4.5 5.39001 4.74 5.80001 5.14 5.91001Z"
        fill={color}
      />
      <path
        d="M16.79 5.23999L19.41 3.80999C19.77 3.60999 19.91 3.15999 19.71 2.78999C19.51 2.42999 19.06 2.28999 18.69 2.48999L16.07 3.91999C15.71 4.11999 15.57 4.56999 15.77 4.93999C15.97 5.29999 16.42 5.43999 16.79 5.23999Z"
        fill={color}
      />
      <path
        d="M2.15999 9.05C1.75999 9.14 1.49999 9.54 1.59999 9.95L2.26999 12.87C2.35999 13.27 2.75999 13.53 3.16999 13.43C3.56999 13.34 3.82999 12.94 3.72999 12.53L3.05999 9.61C2.96999 9.21 2.55999 8.95 2.15999 9.05Z"
        fill={color}
      />
      <path
        d="M14.08 18.31L11.12 17.84C10.71 17.78 10.33 18.06 10.26 18.46C10.2 18.87 10.48 19.25 10.88 19.32L13.84 19.79C14.25 19.85 14.63 19.57 14.7 19.17C14.76 18.76 14.48 18.38 14.08 18.31Z"
        fill={color}
      />
      <path
        d="M1.83998 7.66C2.23998 7.57 2.49998 7.17 2.39999 6.76L2.00998 5.06L2.24998 5.12C2.64999 5.23 3.05999 4.99 3.16999 4.59C3.27998 4.19 3.03999 3.78 2.63999 3.67L1.18998 3.27C0.639985 3.12 0.129985 3.61 0.259985 4.16L0.929985 7.08C1.01998 7.48 1.41998 7.74 1.82998 7.64L1.83998 7.66Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectPolyLassoIcon.displayName = 'SelectPolyLassoIcon';
